/**
 * Headings for a policy that was pasted out of a PDF.
 *
 * The algemene voorwaarden carry seventeen articles and not one heading tag:
 * every "Artikel 3 – Totstandkoming en inhoud overeenkomst" is a bold run
 * inside an ordinary paragraph, and the run itself is shredded across spans by
 * whatever produced the original document — `<b>Artikel </b><span class="s3">
 * <b>3 – </b></span><b>Totstandkoming</b>`. Read as text it comes back whole,
 * which is why this runs in the browser and not in Liquid.
 *
 * Promoting them to H2 is not a rewrite: not a word moves, and the document
 * gains the structure a 3,400-word contract needs — an outline beside it, real
 * landmarks for a screen reader, and anchors to link a clause by.
 *
 * Loaded before awh-article.js, which reads the headings back out to build the
 * outline. Module scripts run in document order, so by the time it looks, these
 * exist. The section has already sized the grid for two columns from the same
 * marker, so nothing shifts once this lands.
 */
const LEAD = /^Artikel\s+\d+\s*[–—-]/i;

const text = (node) => node.textContent.replace(/ /g, ' ').replace(/\s+/g, ' ').trim();

for (const body of document.querySelectorAll('[data-legal-leads]')) {
  const leads = [...body.querySelectorAll('p')].filter((p) => LEAD.test(text(p)));

  // Same three-heading rule as the outline itself: below that it is furniture.
  if (leads.length < 3) continue;

  for (const p of leads) {
    const heading = document.createElement('h2');
    heading.innerHTML = p.innerHTML;
    p.replaceWith(heading);
  }
}
